<template>
	<div class="orderDetail page-container">
		<div class="page-title">
			订单详情
		</div>
		<div class="info">
			<div class="line">
				<div class="key">
					订单编号：
				</div>
				<div class="value">
					{{info.lotOrderId}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					藏品名称：
				</div>
				<div class="value">
					{{info.lotName}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					创建日期：
				</div>
				<div class="value">
					{{info.createAt}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					购买人：
				</div>
				<div class="value">
					{{info.memberNo}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					手机号：
				</div>
				<div class="value">
					{{info.memberPhone}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					是否支付：
				</div>
				<div class="value">
					{{info.payStatus ? '已支付' : '未支付'}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					支付时间：
				</div>
				<div class="value">
					{{info.payTime}}
				</div>
			</div>
			<div class="line">
				<div class="key">
					支付渠道：
				</div>
				<div class="value">
					{{info.channel == 1 ? '微信' : '支付宝'}}
				</div>
			</div>
			<div class="line">
				<el-button type="primary" @click="goBack()">
					返回
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'orderDetail',
		data() {
			return {
				info: {
					lotOrderId: '',
					lotName: '',
					createAt: '',
					memberNo: '',
					memberPhone: '',
					payStatus: false,
					payTime: '',
					channel: ''
				},
				id: ''
			};
		},
		methods: {
			goBack() {
				this.$router.back()
			},
			fetchData() {
				this.$api.orderDetail({
					lotOrderId: this.id
				}, res => {
					console.log(res)
					if (res.code == 200) {
						this.info = res.data
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.orderDetail {
		overflow: hidden;
	}

	.page-title {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0px @vue-spacing-row-sm;
		box-sizing: border-box;
		background: @vue-bg-color-grey;
	}

	.info {
		width: 100%;
		height: calc(100% - 50px);
		padding: @vue-spacing-col-base @vue-spacing-row-base;
		box-sizing: border-box;
		overflow: auto;

		.line {
			width: 100%;
			height: 60px;
			border-bottom: 1px dashed @vue-border-color;
			display: flex;
			align-items: center;
			font-size: @vue-font-size-min + 2;

			.value {
				color: @vue-text-color-grey;
			}
		}
	}
</style>
